import { CountryCode } from './constants/stringConstants';
import { urlLanguageValidations } from './urlDisplayLanguageHandler';

export const globalRegex = /\/global\//;

export const globalRedirectionHandler = (
  routerPath: string,
  countryCode: string,
  isRequestedByBot: boolean
) => {
  const containsGlobal = routerPath.match(globalRegex);
  const isGlobal = countryCode && countryCode !== CountryCode.IN;

  let url = urlLanguageValidations(routerPath); //The router.asPath does not contains any locale information
  const truncatedURL = url.replace(globalRegex, '/');

  if (isGlobal && !isRequestedByBot) {
    // if the country is not add global to the truncated
    url = `/global${truncatedURL}`;
  } else {
    if (containsGlobal) {
      // if the country is not global and the url contains global then remove global
      url = truncatedURL;
    }
  }
  return url;
};
